import { render, staticRenderFns } from "./DetailClass.vue?vue&type=template&id=1632de7f&scoped=true"
import script from "./DetailClass.vue?vue&type=script&lang=js"
export * from "./DetailClass.vue?vue&type=script&lang=js"
import style0 from "./detailClass.css?vue&type=style&index=0&id=1632de7f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1632de7f",
  null
  
)

export default component.exports